.link {
  font-size: var(--fs-7);
  text-decoration: none;
  width: max-content;
  border-bottom: var(--border-width) solid transparent;
  padding: 0 0 var(--space-xs) 0;
  transition:
    color var(--duration-xs),
    border-color var(--duration-xs);
}

.primary {
  color: var(--color-primary);
  border-color: var(--color-secondary);
}

.primary:hover {
  color: var(--color-secondary);
  border-color: transparent;
}
